import loadable from '@loadable/component';

const inputTypes = {
	radio: loadable(() => import('/views/partials/input-types/radio')),
	checkbox: loadable(() => import('/views/partials/input-types/checkbox')),
	textarea: loadable(() => import('/views/partials/input-types/textarea')),
	text: loadable(() => import('/views/partials/input-types/text')),
	date: loadable(() => import('/views/partials/input-types/text')),
	phone: loadable(() => import('/views/partials/input-types/text')),
	email: loadable(() => import('/views/partials/input-types/text')),
	number: loadable(() => import('/views/partials/input-types/text')),
	password: loadable(() => import('/views/partials/input-types/text')),
	price: loadable(() => import('/views/partials/input-types/text')),
	qr: loadable(() => import('/views/partials/input-types/text')),
	select: loadable(() => import('/views/partials/input-types/select')),
	hidden: loadable(() => import('/views/partials/input-types/hidden')),
	toggle: loadable(() => import('/views/partials/input-types/toggle')),
};

export default inputTypes;
